import { NgModule } from '@angular/core';
import { LexiconModule } from '@galaxy/lexicon';
import { TranslateModule } from '@ngx-translate/core';
import baseTranslation from './i18n/assets/en_devel.json';

@NgModule({
  imports: [
    TranslateModule,
    LexiconModule.forChild({
      componentName: 'business-center/inbox',
      baseTranslation: baseTranslation,
    }),
  ],
})
export class TranslationModule {}
